import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { WorkCenterDto } from '@app/generated/model';
import { buildWorkCenterForm } from './work-center-form-builder';
import { WorkCenterService } from '@app/core/services/work-center.service';

@Component({
  selector: 'app-edit-work-center-dialog',
  templateUrl: './edit-workcenter.component.html',
  styleUrls: ['./edit-workcenter.component.scss'],
  standalone: false,
})
export class EditWorkCenterComponent implements OnInit {
  form: UntypedFormGroup;
  description: string;
  private siteId: string;
  private workCenterId: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<EditWorkCenterComponent>,
    private workCenterService: WorkCenterService,
    @Inject(MAT_DIALOG_DATA) private data: WorkCenterDto,
  ) {
    this.siteId = data.siteId;
    this.workCenterId = data.id;
    this.description = `Edit Work Center: ${data.id}`;
  }

  ngOnInit(): void {
    this.form = buildWorkCenterForm(this.formBuilder, this.data);
  }

  onSave(): void {
    if (!this.form.valid) {
      return;
    }
    const formValue = this.form.getRawValue();
    const payload: WorkCenterDto = {
      id: this.workCenterId,
      name: formValue.name,
      number: formValue.number,
      siteId: this.siteId,
    };
    this.workCenterService.updateWorkCenter(this.siteId, this.workCenterId, payload).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => {
        if (err?.status === 404 && err?.url?.includes(`/admin/sites/${this.siteId}/work-centers/`)) {
          this.dialogRef.close(true);
          return;
        }
        console.error('Error updating work center:', err);
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
